import { render } from "./DefaultField.vue?vue&type=template&id=477118ab"
import script from "./DefaultField.vue?vue&type=script&lang=js"
export * from "./DefaultField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DefaultField.vue"]])

export default __exports__